module.exports = __webpack_public_path__ + "static/media/menu.b9ba4162.svg";